import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaChartLine,
  FaRobot,
  FaCloud,
  FaGlobe,
  FaMobileAlt,
  FaShieldAlt,
} from "react-icons/fa";
import "./IndustrySolutions.css";

const IndustrySolutions = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const industries = [
    {
      icon: <FaGlobe />,
      title: "FinTech",
      desc: "Secure digital payments, banking automation, and wealth management systems built with precision.",
    },
    {
      icon: <FaRobot />,
      title: "HealthTech",
      desc: "Telemedicine platforms, EMR systems, and AI-driven diagnostics for modern healthcare.",
    },
    {
      icon: <FaCloud />,
      title: "EdTech",
      desc: "Scalable e-learning platforms, virtual classrooms, and management systems.",
    },
    {
      icon: <FaChartLine />,
      title: "AgriTech",
      desc: "Smart farming solutions, crop monitoring IoT, and supply chain traceability.",
    },
    {
      icon: <FaMobileAlt />,
      title: "GovTech",
      desc: "Citizen portals, e-governance suites, and smart city infrastructure.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Cybersecurity",
      desc: "Threat intelligence, identity protection, and compliance frameworks.",
    },
  ];

  return (
    <section className="industry-section">
      <div className="bg-graphic"></div>
      
      <div className="section-header" data-aos="fade-up">
        <span className="section-label">Our Expertise</span>
        <h2 className="section-title">
          Transforming Key <br />
          <span>Industries</span>
        </h2>
        <p className="section-desc">
          We deliver tailored software solutions that drive innovation across 
          diverse sectors, ensuring scalability and security.
        </p>
      </div>

      <div className="industry-grid">
        {industries.map((item, index) => (
          <div key={index} className="industry-card" data-aos="fade-up" data-aos-delay={index * 100}>
            <div className="icon-container">
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <div className="card-link">
              CONTACT US <span>→</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IndustrySolutions;